module.exports = __webpack_public_path__ + "static/media/Hoist_ios_2_preview.b4c0ece6.jpg";